import React from "react";
import { CustomMenuItem } from "src/components/NetworkMenuDropdown";
import { StyledTypographyHeaderItem } from "src/components/Styled/typography";
import UseCasesMenuDropdown from "src/components/UseCasesDropdown";
import pageURL from "src/constants/pageURL";
import { NavLink } from "react-router-dom";
import { NavigationMenu, NavLinkWithItemsContainer } from "./StyledComponents";

const itemsNetworkMenu: CustomMenuItem[] = [
  {
    id: 1,
    name: "Network",
  },
  {
    id: 3,
    name: "Reliable Network: A Decentralized Foundation",
    route: pageURL.networkDecFoundation,
  },
  {
    id: 4,
    name: "Developer-Friendly Tools: Build with ease",
    route: pageURL.networkDevTools,
  },
];

const itemsUseCasesMenu: CustomMenuItem[] = [
  {
    id: 1,
    name: "Use Cases",
  },
  {
    id: 3,
    name: "GameFi & NFT Storage",
    route: pageURL.useCaseGameFi,
    description: "Safeguarding Digital Assets",
  },
  {
    id: 4,
    name: "Enterprise Data",
    route: pageURL.useCaseEnterpriseData,
    description:
      "Revolutionizing Enterprise Data Storage for Cost-Saving Efficiency",
  },
  {
    id: 5,
    name: "CDN Acceleration",
    route: pageURL.useCaseCdnAcceleration,
    description:
      "Supercharging Content Delivery with Stratos Lightning-Fast CDN",
  },
  {
    id: 6,
    name: "Video Streaming",
    route: pageURL.useCaseVideoSreaming,
    description:
      "Streamlining our Video Distribution with Decentralized Network ",
  },
  {
    id: 7,
    name: "Decentralized Applications (DApps)",
    route: pageURL.useCaseDapp,
    description: "Empowering Web3 Developers",
  },
];

export const desktopMenu = (viewName: any) => {
  return (
    <NavigationMenu className="navigation_menu" $viewName={viewName}>
      <NavLinkWithItemsContainer
        $viewName={viewName}
        className="connect_wallet_button_container"
      >
        <UseCasesMenuDropdown
          itemOverlayClassName="validators-list-overlay"
          menuItemsData={itemsNetworkMenu}
        />
      </NavLinkWithItemsContainer>
      <NavLinkWithItemsContainer
        $viewName={viewName}
        className="connect_wallet_button_container"
      >
        <UseCasesMenuDropdown
          itemOverlayClassName="usecases-list-overlay"
          menuItemsData={itemsUseCasesMenu}
        />
      </NavLinkWithItemsContainer>
      <NavLink to={pageURL.wallet}>
        {({ isActive }) => (
          <StyledTypographyHeaderItem className={isActive ? "active" : ""}>
            Wallet
          </StyledTypographyHeaderItem>
        )}
      </NavLink>
      <NavLink to={pageURL.ecosystem}>
        {({ isActive }) => (
          <StyledTypographyHeaderItem className={isActive ? "active" : ""}>
            Ecosystem
          </StyledTypographyHeaderItem>
        )}
      </NavLink>
      <NavLink to={pageURL.communityCollaborate}>
        {({ isActive }) => (
          <StyledTypographyHeaderItem className={isActive ? "active" : ""}>
            Community
          </StyledTypographyHeaderItem>
        )}
      </NavLink>
      <NavLink to={pageURL.resourcesGuide}>
        {({ isActive }) => (
          <StyledTypographyHeaderItem className={isActive ? "active" : ""}>
            Resources
          </StyledTypographyHeaderItem>
        )}
      </NavLink>
      <NavLink to={pageURL.home}>
        {({ isActive }) => (
          <StyledTypographyHeaderItem className={isActive ? "active" : ""}>
            Blog
          </StyledTypographyHeaderItem>
        )}
      </NavLink>
      <NavLink to={pageURL.contactUs}>
        {({ isActive }) => (
          <StyledTypographyHeaderItem className={isActive ? "active" : ""}>
            Contact Us
          </StyledTypographyHeaderItem>
        )}
      </NavLink>
    </NavigationMenu>
  );
};
